import Swiper, { Navigation, Pagination } from 'swiper';

document.addEventListener( 'DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.review-section');

	sections.forEach((section) => {
		const sliderButtonPrev = section.querySelector('.slider-button-prev');
		const sliderButtonNext = section.querySelector('.slider-button-next');

		// const customPagination = (swiper, current, total) => {
		// 	const progressbarFillClass = swiper.params.pagination.progressbarFillClass;
		// 	const previousIndex = swiper.previousIndex ? swiper.previousRealIndex + 1 : 1;
		// 	const width = Math.ceil(current / total * 100) + '%';
		// 	const previousWidth = Math.ceil(previousIndex / total * 100) + '%';

		// 	return '<span class="'+progressbarFillClass+'" style="width: '+width+'; --width: '+width+'; --previous-width: '+previousWidth+'"></span>'
		// }

		// const updateClasses = (type) => {
		// 	swiper.pagination.el.setAttribute('class', 'swiper-pagination');
		// 	if (!swiper.pagination.el.classList.contains('swiper-pagination-' + type)) {
		// 		swiper.pagination.el.classList.add('swiper-pagination-' + type)
		// 	}
		// 	swiper.pagination.el.classList.toggle('swiper-pagination-horizontal', swiper.params.direction === 'horizontal')
		// 	swiper.pagination.el.classList.toggle('swiper-pagination-clickable', !swiper.params.pagination.clickable)
		// }

		// const togglePaginationType = (type = 'custom') => {
		// 	swiper.params.pagination.type = type;
		// 	swiper.pagination.destroy();
		// 	updateClasses(type);
		// 	swiper.pagination.el.innerHTML = '';
		// 	swiper.pagination.init();
		// 	swiper.pagination.render();
		// 	swiper.pagination.update();
		// }

		const swiper = new Swiper(section.querySelector('.swiper'), {
			modules: [Navigation, Pagination],
			loop: false,
	
			slidesPerView: 1,
			spaceBetween: 30,
			watchSlidesProgress: true,
	
			breakpoints: {
				576: {
					slidesPerView: 1.5,
					// type: "bullets",
				},
				768: {
					slidesPerView: 2,
					// type: "custom",
				},
				992: {
					slidesPerView: 3,
					// type: "custom",
				}
			},

			pagination: {
				direction: 'horizontal',
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
				// renderCustom: (swiper, current, total) => {return customPagination(swiper, current, total)}
				
			},

			navigation: {
				nextEl: sliderButtonNext,
				prevEl: sliderButtonPrev,
			},

			// on: {
			// 	afterInit: (swiper) => {
			// 		setTimeout(()=>{
			// 			const type = swiper.currentBreakpoint == 'max' ? swiper.params.pagination.type : swiper.params.breakpoints[swiper.currentBreakpoint]
			// 			if (type !== swiper.params.pagination.type) {
			// 				togglePaginationType(swiper.params.breakpoints[swiper.currentBreakpoint].type);
			// 			}
			// 		}, 10)
			// 	},
			// }
		});
		// swiper.on('breakpoint', (swiper, breakpointParams) => {
		// 	const type = breakpointParams.pagination ? breakpointParams.pagination.type : breakpointParams.type;

		// 	if ( type !== swiper.params.pagination.type) {
		// 		togglePaginationType(type);
		// 	} else {
		// 		updateClasses(type);
		// 	}
		// })

		// window.swiper = swiper
	})
} )